<template>
  <tbody>
    <tr v-if="!rows.records || rows.records.length < 1">
      <td :colspan="colSpan" align="center">No records found.</td>
    </tr>
    <tr v-for="(row, index) in rows.records" :key="index">
      <td>
        <router-link
          :to="{
            name: 'MemberPolicyDetail',
            params: { policyId: encodedId(row.policy_id) },
          }"
          target="_blank"
        >
          <span class="brand-color">
            {{ row.policy_id }}
          </span>
        </router-link>
        <br />
        <span class="member" v-if="row.user_info">
          {{ row.user_info.name || "" }}
        </span>
      </td>
      <td>
        {{ row.type_name }}
      </td>
      <td>
        {{ row.information?row.information:'' | truncate(100) }}
      </td>
    
      <td>
        {{ row.status_name }}
        <br />
        <template
          v-if="
            row.status == 'completed' ||
            row.status == 'rejected' ||
            row.status == 'approved' ||
            row.status == 'canceled'
          "
        >
          <span class="updated-at">{{ row.updated_at }}</span>
        </template>
      </td>
      <td v-if="isEnrollPrime">
        {{ row.cards_requested}}
      </td>
      <td>
        {{ row.created_at }}
      </td>
      <td>
        <div class="action-icons">
          <custom-button
            v-if="row.document"
            title="Download Document"
            iconClass="fas fa-download"
            @onClicked="downloadDocument(row.document)"
          />
            <custom-button
              title="Detail"
              iconClass="fas fa-eye"
              @onClicked="openModal(row, 'repInfoRequestDetailModal')"
            />
          <template v-if="isEnrollPrime">
            <template v-if="row.status == 'pending'">
                <custom-button
                  title="Approve Request"
                  iconClass="fas fa-check"
                  @onClicked="openModal(row, 'repApproveModal')"
                />
                <custom-button
                  title="Reject Request"
                  iconClass="fas fa-xmark"
                  @onClicked="openModal(row, 'repRejectModal')"
                /> 
            </template>
                <custom-button v-if="row.status == 'in_progress' && checkIfPaymentPost(row.repInfoPaymentDetails)"
                  title="Complete request"
                  iconClass="fas fa-wallet"
                  @onClicked="completeRequest(row.id)"
                />
          </template>
          <template v-else>
            <template v-if="row.status == 'pending'">
              <custom-button
                title="Cancel Request"
                iconClass="fas fa-times"
                @onClicked="openModal(row, 'repInfoRequestCancelModal')"
              />
            </template>
          </template>  
        </div>
      </td>
    </tr>
  </tbody>
</template>
<script>
import isEnrollPrimeUtil from "@/utils/isEnrollPrimeUtil";
import AdminApi from '@/resource/AdminApi'

export default {
  props: {
    rows: {
      required: true,
    },
    colSpan: {
      type: Number,
      required: true,
    },
  },
  methods: {
    downloadDocument(url) {
      window.open(url, "_blank");
    },
    encodedId(id) {
      return btoa(id);
    },
    openModal(row, type) {
      this.row = row;
      this.$emit("onRowOpen", row, type);
    },
    checkIfPaymentPost(paymentStatusCheck){
        if (paymentStatusCheck.length === 0){
              return true;
        }
        paymentStatusCheck = paymentStatusCheck.filter((item) => {
            return item.status === 'Paid';
        });
        return paymentStatusCheck.length > 0 ? true : false
    },
    completeRequest(id){
      let url = '/api/v2/rep-info-request/complete-request';
      let data = {id:id}
      this.$confirm({
        title: "Complete Request",
        message: `Do you want to complete this request?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            let loader = this.$loading.show();
            AdminApi.put(url, data)
              .then((res) => {
                this.$notify(res.data.message)
                this.$emit("onSuccess")
              })
              .catch((err) => {
                console.log(err)
                this.$notify("Something went wrong. Please try again.", "error");
              }).finally(() => {
              loader.hide()
            })
          }
        },
      });
    }
  },
  computed:{
    isEnrollPrime() {
      return isEnrollPrimeUtil.isEnrollPrime();
    },
  }
};
</script>
<style scoped>
.updated-at{
  font-size: 11px;
}
</style>